import {
  CREATEPATIENTVISIT,
  GETPATIENTVISIT,
  GETPATIENTVISITBYID,
  UPDATEPATIENTVISIT,
  DELETEPATIENTVISIT,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case CREATEPATIENTVISIT:
      return {
        ...state,
        patientVisitSaveStatus: action.payload.success,
      };
    case GETPATIENTVISIT:
      return {
        ...state,
        patientVisitList: action.payload.data,
      };
    case GETPATIENTVISITBYID:
      return {
        ...state,
        selectedPatientVisit: action.payload.data,
      };
    case UPDATEPATIENTVISIT:
      return {
        ...state,
        patientVisitUpdateStatus: action.payload.success,
      };
    case DELETEPATIENTVISIT:
      return {
        ...state,
        patientVisitDeleteStatus: action.payload.success,
      };
    default:
      return state;
  }
}